import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
    { path: '/about', label: 'About Us' },
    { path: '/contact', label: 'Contact' }
  ];

  const services = [
    'Direct Taxation',
    'Indirect Taxation',
    'Statutory Audit',
    'Tax Audit',
    'Bank Audit',
    'GST Compliance'
  ];

  return (
    <footer className="bg-gradient-to-br from-slate-900 via-[#1B5E20] to-[#0D3D13] text-white">
      <div className="container mx-auto px-6">
        {/* Main Footer Content */}
        <div className="py-16 grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_ca-firm-site/artifacts/dy4dtb6i_IMG_5726.PNG"
                alt="ICAI Logo"
                className="h-10 w-10 object-contain"
              />
              <div>
                <h3 className="text-xl font-bold text-white">
                  S.K. Mundhra & Co.
                </h3>
                <p className="text-white text-xs">
                  Chartered Accountants | Since 1991
                </p>
              </div>
            </div>
            <p className="text-gray-300 leading-relaxed mb-6 text-sm">
              Over 35 years of trusted service delivering excellence in audit, taxation, and compliance with unwavering integrity.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <button
                    onClick={() => navigate(link.path)}
                    className="text-gray-300 hover:text-white transition-colors text-sm"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white">Our Services</h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <button
                    onClick={() => navigate('/services')}
                    className="text-gray-300 hover:text-white transition-colors text-sm"
                  >
                    {service}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-6 text-white">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-[white] flex-shrink-0 mt-0.5" />
                <span className="text-gray-300 text-sm">
                  D/6 Civil Township<br />
                  Rourkela, Odisha<br />
                  India - 769004
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-[white] flex-shrink-0" />
                <a href="tel:+919437046671" className="text-gray-300 hover:text-[white] transition-colors text-sm">
                  +91 9437046671
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="h-5 w-5 text-[white] flex-shrink-0 mt-0.5" />
                <a href="mailto:SKM.RKL@REDIFFMAIL.COM" className="text-gray-300 hover:text-[white] transition-colors text-sm break-all">
                  SKM.RKL@REDIFFMAIL.COM
                </a>
              </li>
            </ul>
            <div className="mt-6 pt-6 border-t border-slate-700">
              <p className="text-gray-400 text-sm">
                <span className="font-semibold text-[white]">Business Hours:</span><br />
                Monday - Saturday<br />
                9:00 AM - 7:00 PM
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} S.K. Mundhra & Co. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <button className="text-gray-400 hover:text-[white] transition-colors">
                Privacy Policy
              </button>
              <button className="text-gray-400 hover:text-[white] transition-colors">
                Terms of Service
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
